define('Magento_Checkout/js/view/summary/item/details',[
    'uiComponent',
    'escaper',
    'uiRegistry',
    'ko',
    'underscore',
    'mage/template',
    'mage/translate',
    'Magento_Catalog/js/price-utils',
    'Magento_Checkout/js/model/quote',
    'Magento_Ui/js/modal/confirm',
    'text!TescoMobile_Checkout/template/totals-item-payment-modal.html',
    'text!TescoMobile_Checkout/template/totals-item-promo-modal.html'
], function (Component, escaper, registry, ko, _, mageTemplate, $t, priceUtils, quote, confirmModal, payTmp, promoTmp) {
    'use strict';

    return Component.extend({
        defaults: {
            template: 'Magento_Checkout/summary/item/details',
            allowedTags: ['b', 'strong', 'i', 'em', 'u'],
            extensionTemplates: {
                device: [],
                tariff: [],
                monthly: [],
                today: [],
                upfront: [],
                esim: []
            }
        },

        /**
         * @param price
         * @returns {*}
         */
        getFormattedPrice: function (price) {
            return priceUtils.formatPrice(price, quote.getPriceFormat());
        },

        /**
         * @param data
         */
        openPromoModal: function (data) {
            var promoTemplate = mageTemplate(promoTmp),
                infoData = _.extend({}, {
                    content: data.details
                });
            confirmModal({
                title: data.text,
                content: promoTemplate({
                    data: infoData
                }),
                clickableOverlay: false,
                buttons: [{
                    text: $t('OK'),
                    class: 'action-primary action-accept',
                    /**
                     * Click handler.
                     */
                    click: function (event) {
                        this.closeModal(event, true);
                    }
                }]
            });
        },

        /**
         * @param data
         */
        openPayPopup: function (data) {
            var payTemplate = mageTemplate(payTmp),
                infoData = _.extend({}, {
                    content: data.extension_attributes.tm_options.payment_data
                });
            confirmModal({
                content: payTemplate({
                    data: infoData
                }),
                buttons: [],
                clickableOverlay: false,
                modalClass: 'payment'
            });
        },

        /**
         * @param {Object} quoteItem
         * @return {String}
         */
        getNameUnsanitizedHtml: function (quoteItem) {
            var txt = document.createElement('textarea');

            txt.innerHTML = quoteItem.name;

            return escaper.escapeHtml(txt.value, this.allowedTags);
        },

        /**
         * @param quoteItem
         * @returns {String|*}
         */
        getTextUnsanitizedHtml: function (quoteItem) {
            var txt = document.createElement('textarea');

            txt.innerHTML = quoteItem.name;

            return escaper.escapeHtml(txt.value, this.allowedTags);
        },

        /**
         * @param {Object} quoteItem
         * @return {String}Magento_Checkout/js/region-updater
         */
        getValue: function (value) {
            return this.getFormattedPrice(value);
        },

        /**
         * Check does quote containes multiple items
         * @return {boolean}
         */
        isShowDetailsVisible: function () {
            return (quote.getItems().length > 1);
        }
    });
});

